import { NumberLiteralType } from "typescript";
import { IChooseAction } from "../Components/Utilities/Popups/EditRowPopup";

export interface ICustomer {
  id: number;
  name: string;
}

export interface ITable {
  id: number;
  major_version: number;
  minor_version: number;
  customer_id: number;
  customer: {
    name: string;
  };
}

export interface IRecord {
  id: number;
  omnium_value: string;
  customer_value: string;
  de_value: string;
  en_value: string;
  fr_value: string;
  it_value: string;
  master: string;
  order: string;
  de_abbr: string;
  en_abbr: string;
  fr_abbr: string;
  it_abbr: string;
  edited: boolean;
  deleted: boolean;

  type_id: number;
  type_name: string;
}

export interface ISubmitEditForm {
  omnium_value: string;
  customer_value: string;
  de_value: string;
  en_value: string;
  fr_value: string;
  it_value: string;
  master: string;
  order: string;
  de_abbr: string;
  en_abbr: string;
  fr_abbr: string;
  it_abbr: string;
}

export interface IRowProps extends IRecord {}

export interface IOmniumType {
  id: number;
  name: string;
}

export interface IUser {
  id: number;
  user_name: string;
  favorites: IFavorite[];
  token: string;
}

interface IFavorite {
  id: number;
  user_id: number;
  table: {
    id: number;
    major_version: number;
    minor_version: number;
    customer_id: number;
    customer: {
      id: number;
      name: string;
    };
  };
  table_id: number;
}

export interface IPopupProps {
  offsetX: number;
  offsetY: number;
}

export enum PopupType {
  ChooseAction,
  EditRecord,
  DeleteRecord,
  DuplicateRecord,
  AddNewType,
  AddRecord,
  AddFavorite,
  CreateTable,
  UploadTable,
  DuplicateTable,
  ConfirmAction,
  EditType,
}

export enum TableColumn {
  OmniumValues = "omnium_value",
  CustomerValues = "customer_value",
  DeValue = "de_value",
  EnValue = "en_value",
  FrValue = "fr_value",
  ItValue = "it_value",
  Order = "order",
  Master = "master",
  DeAbb = "de_abb",
  EnAbb = "en_abb",
  FrAbb = "fr_abb",
  ItAbb = "it_abb",
}

export interface IModalState {
  severity: string;
  message: string;
  open: boolean;
}

export interface ISortingState {
  column: TableColumn;
  ascending: boolean;
}

export interface IPopupManagerProps {
  type: PopupType;
  //TODO: THIS IS NOT OKAY
  props: IChooseAction | IOmniumType | null | any;
}

export interface IRecordType3 {
  id: number;
  customer_value: string;
  en_value: string;
  de_value: string;
  fr_value: string;
  it_value: string;
  master: string;
  order: number;
  type_id: number;
  type_name: string;
  edited: boolean;
  deleted: boolean;
}

export const EMPTY_USER = { user_name: "", id: 0, favorites: [], token: "" };
